import { useMemo } from "react"
import { Badge } from "../../../../../features/ui"
import { define } from "../../../../../utils/typeUtils"
import { useBranchLoaders } from "../../../loaders/branchLoaders"

type Props = {
    branchId: string
}
export const BranchBadge = (props: Props) => {
    const { branchId } = props

    const branchLoaders = useBranchLoaders()

    const branch = useMemo(() => branchLoaders().findBranch(branchId), [branchId])
    
    return <Badge label={define(branch).name} />
}
